import createImmutableSelector from 'lib/immutable/selector'
import { IVolunteers } from './../models'

// TODO: import Store type and add reducer type in Store interface
const getVolunteers = (state: any): IVolunteers => state.get('volunteersReducer')

export const volunteersSelector = createImmutableSelector(getVolunteers, (volunteers) => volunteers)
